!function(o,r){"object"==typeof exports&&"object"==typeof module?module.exports=r():"function"==typeof define&&define.amd?define([],r):"object"==typeof exports?exports.storeblocks=r():o.storeblocks=r()}(self,(()=>(()=>{"use strict";var o={546:(o,r,e)=>{e.d(r,{Contained:()=>l,Icon:()=>d,Outlined:()=>s,Text:()=>c});const t=require("styled-components");var n=e.n(t);const a=require("styled-system"),i=n().button.attrs({className:"button"})`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  position: relative;

  height: 40px;
  padding: 8px 24px;
  border-radius: 2px;
  border: none;
  box-sizing: border-box;

  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;

  cursor: pointer;
  transition-property: border, background-color, color;
  transition-duration: 0.2s;
  -webkit-font-smoothing: antialiased;

  &:focus {
    outline: var(--outline);
    outline-offset: 4px;
  }

  &:focus:not(:focus-visible) {
    outline: none;
    outline-offset: none;
  }

  &:focus-visible {
    outline: var(--outline);
    outline-offset: 4px;
  }

  &::-moz-focus-inner {
    border: 0;
  }

  &::after {
    content: '';

    position: absolute;

    top: -4px;
    bottom: -4px;
    left: 0;
    right: 0;
  }

  & > i {
    text-align: left;
    white-space: nowrap;
  }

  & > .icon-left {
    margin-right: 8px;
  }

  & > .icon-right {
    margin-left: 8px;
  }

  ${a.space}
`,l=n()(i).attrs({className:"button"})`
  background: var(--color-primary);
  color: var(--color-on-primary);

  &:hover,
  &:focus {
    color: var(--color-on-primary);
    background: var(--color-primary-variant);
  }

  &:active {
    background: var(--color-primary-pressed);
  }

  &[aria-disabled='true'] {
    background: var(--color-disabled-variant);
    color: var(--color-disabled);
    cursor: not-allowed;
  }
`,s=n()(i)`
  color: var(--color-primary);
  background: rgba(0, 0, 0, 0);
  border: 1px solid var(--color-primary);

  padding: 7px 23px;

  &:hover,
  &:focus {
    background: var(--color-overlay-hover-darken);
  }

  &:active {
    color: var(--color-primary-pressed);
    border: 1px solid var(--color-primary-pressed);
  }

  &[aria-disabled='true'] {
    border: 1px solid var(--color-disabled-variant);

    background: rgba(0, 0, 0, 0);
    color: var(--color-disabled);
    cursor: not-allowed;
  }

  &::after {
    content: '';

    position: absolute;

    top: -5px;
    bottom: -5px;
    left: 0;
    right: 0;
  }
`,c=n()(i)`
  color: var(--color-primary);
  background: rgba(0, 0, 0, 0);

  &:hover,
  &:active,
  &:focus {
    background: var(--color-overlay-hover-darken);
    color: var(--color-primary-variant);
  }

  &[aria-disabled='true'] {
    background: rgba(0, 0, 0, 0);
    color: var(--color-disabled);
    cursor: not-allowed;
  }
`,d=n().button.attrs({className:"button"})`
  position: relative;
  display: inline-flex;

  padding: 0;

  font-size: 16px;
  line-height: 16px;
  color: var(--color-primary);

  border: none;
  /* border-radius: 50%; */
  background-color: transparent;

  transition-property: color;
  transition-duration: 0.2s;

  text-decoration: none;

  cursor: pointer;

  &:hover > i {
    box-shadow:
      inset 0 0 0 8px var(--color-overlay-hover-darken),
      0 0 0 8px var(--color-overlay-hover-darken);
  }

  &:focus {
    outline: var(--outline);
    outline-offset: 16px;
  }
  &:focus:not(:focus-visible) {
    outline: 0;
  }
  &:focus-visible {
    outline: var(--outline);
    outline-offset: 16px;
  }

  & > i {
    margin: 0;
    border-radius: 50%;
    white-space: nowrap;
    transition-property: box-shadow;
    transition-duration: 0.2s;
  }

  ${({size:o=16})=>o&&t.css`
      & > i {
        font-size: ${o}px;
        line-height: ${o}px;
      }
    `};

  &::after {
    content: '';

    position: absolute;

    top: -16px;
    bottom: -16px;
    left: -16px;
    right: -16px;
  }

  &[aria-disabled='true'] {
    color: var(--color-disabled);

    &:hover > i {
      box-shadow: none;
    }

    cursor: not-allowed;
  }

  ${({color:o})=>o&&t.css`
      & > i {
        color: var(--color-${o}) !important;
      }
    `}

  ${a.space}
`}},r={};function e(t){var n=r[t];if(void 0!==n)return n.exports;var a=r[t]={exports:{}};return o[t](a,a.exports,e),a.exports}e.n=o=>{var r=o&&o.__esModule?()=>o.default:()=>o;return e.d(r,{a:r}),r},e.d=(o,r)=>{for(var t in r)e.o(r,t)&&!e.o(o,t)&&Object.defineProperty(o,t,{enumerable:!0,get:r[t]})},e.o=(o,r)=>Object.prototype.hasOwnProperty.call(o,r),e.r=o=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(o,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(o,"__esModule",{value:!0})};var t={};return(()=>{e.r(t),e.d(t,{Button:()=>s,default:()=>c});const o=require("react");var r=e.n(o);const n=require("@storeblocks/loading-indicator");var a=e.n(n);const i=require("@storeblocks/icon");var l=e(546);const s=(0,o.forwardRef)(((o,e)=>{var{disabled:t,variant:n="contained",loading:s=!1,iconLeft:c="",iconRight:d="",onClick:p,children:u,size:b=16,color:f,as:v="button",type:x="button"}=o,y=function(o,r){var e={};for(var t in o)Object.prototype.hasOwnProperty.call(o,t)&&r.indexOf(t)<0&&(e[t]=o[t]);if(null!=o&&"function"==typeof Object.getOwnPropertySymbols){var n=0;for(t=Object.getOwnPropertySymbols(o);n<t.length;n++)r.indexOf(t[n])<0&&Object.prototype.propertyIsEnumerable.call(o,t[n])&&(e[t[n]]=o[t[n]])}return e}(o,["disabled","variant","loading","iconLeft","iconRight","onClick","children","size","color","as","type"]);const m="icon"===n;let g=l.Contained;switch(n){case"outlined":g=l.Outlined;break;case"text":g=l.Text;break;case"icon":g=l.Icon;break;default:g=l.Contained}return r().createElement(g,Object.assign({},y,{as:v,ref:e,variant:n,"aria-disabled":t,onClick:t||s?o=>o.preventDefault():p,size:b,color:f,type:"button"===v?x:void 0,disabled:t}),m?null:s&&r().createElement(a(),{size:"small",color:"contained"===n?"on-primary":"primary"}),!s&&r().createElement(r().Fragment,null,c&&r().createElement(i.SystemIcon,{className:"icon-left",name:c,size:m?b:16,"aria-hidden":!0}),!m&&r().createElement("span",null,u),d&&r().createElement(i.SystemIcon,{className:"icon-right",name:d,size:m?b:16,"aria-hidden":!0})))})),c=s})(),t})()));
//# sourceMappingURL=index.js.map